<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Nilai Makalah">
            <br>
            <common-training-header :withUser="true"/>
        </a-page-header>

        <a-card type="inner" size="small">
            <a-table
                class="pcp-table"
                :columns="columns"
                :dataSource="tableData"
                rowKey="id"
                :loading="loading"
                :pagination="false"
                bordered>

                <!-- <div slot="presentasi_1" slot-scope="record">
                    <center>{{ record.scorer.presentasi_1 }}</center>
                </div>

                <div slot="isi_1" slot-scope="record">
                    <center>{{ record.scorer.isi_1 }}</center>
                </div>

                <div slot="penulisan_1" slot-scope="record">
                    <center>{{ record.scorer.penulisan_1 }}</center>
                </div>

                <div slot="presentasi_2" slot-scope="record">
                    <center>{{ record.scorer.presentasi_2 }}</center>
                </div>

                <div slot="isi_2" slot-scope="record">
                    <center>{{ record.scorer.isi_2 }}</center>
                </div>

                <div slot="penulisan_2" slot-scope="record">
                    <center>{{ record.scorer.penulisan_2 }}</center>
                </div>

                <div slot="presentasi_3" slot-scope="record">
                    <center>{{ record.scorer.presentasi_3 }}</center>
                </div>

                <div slot="isi_3" slot-scope="record">
                    <center>{{ record.scorer.isi_3 }}</center>
                </div>

                <div slot="penulisan_3" slot-scope="record">
                    <center>{{ record.scorer.penulisan_3 }}</center>
                </div> -->

                <div slot="total_presentasi" slot-scope="record">
                    <center>{{ record.scorer.total_presentasi }}</center>
                </div>

                <div slot="total_isi" slot-scope="record">
                    <center>{{ record.scorer.total_isi }}</center>
                </div>

                <div slot="total_penulisan" slot-scope="record">
                    <center>{{ record.scorer.total_penulisan }}</center>
                </div>

                <div slot="final_score" slot-scope="record">
                    <center>{{ record.scorer.final_score }}</center>
                </div>
            </a-table>
        </a-card>
    </div>
</template>

<script>
    const columns = [
        // {
        //     key: 'score_1',
        //     title: 'Penilai 1',
        //     scopedSlots: {customRender: 'raw_score'},
        //     children: [
        //         {
        //             key: 'presentasi_1',
        //             title: 'Presentasi',
        //             align: 'center',
        //             scopedSlots: {customRender: 'presentasi_1'},
        //         },
        //         {
        //             key: 'isi_1',
        //             title: 'Isi',
        //             align: 'center',
        //             scopedSlots: {customRender: 'isi_1'},
        //         },
        //         {
        //             key: 'penulisan_1',
        //             title: 'Penulisan',
        //             align: 'center',
        //             scopedSlots: {customRender: 'penulisan_1'},
        //         },
        //     ]
        // }, {
        //     key: 'score_2',
        //     title: 'Penilai 2',
        //     scopedSlots: {customRender: 'raw_score'},
        //     children: [
        //         {
        //             key: 'presentasi_2',
        //             title: 'Presentasi',
        //             align: 'center',
        //             scopedSlots: {customRender: 'presentasi_2'},
        //         },
        //         {
        //             key: 'isi_2',
        //             title: 'Isi',
        //             align: 'center',
        //             scopedSlots: {customRender: 'isi_2'},
        //         },
        //         {
        //             key: 'penulisan_2',
        //             title: 'Penulisan',
        //             align: 'center',
        //             scopedSlots: {customRender: 'penulisan_2'},
        //         },
        //     ]
        // }, {
        //     key: 'score_3',
        //     title: 'Penilai 3',
        //     scopedSlots: {customRender: 'raw_score'},
        //     children: [
        //         {
        //             key: 'presentasi_3',
        //             title: 'Presentasi',
        //             align: 'center',
        //             scopedSlots: {customRender: 'presentasi_3'},
        //         },
        //         {
        //             key: 'isi_3',
        //             title: 'Isi',
        //             align: 'center',
        //             scopedSlots: {customRender: 'isi_3'},
        //         },
        //         {
        //             key: 'penulisan_3',
        //             title: 'Penulisan',
        //             align: 'center',
        //             scopedSlots: {customRender: 'penulisan_3'},
        //         },
        //     ]
        // },
        {
            key: 'total',
            title: 'Total Nilai',
            scopedSlots: {customRender: 'total'},
            children: [
                {
                    key: 'total_presentasi',
                    title: 'Presentasi 20%',
                    align: 'center',
                    scopedSlots: {customRender: 'total_presentasi'},
                },
                {
                    key: 'total_isi',
                    title: 'Isi 60%',
                    align: 'center',
                    scopedSlots: {customRender: 'total_isi'},
                },
                {
                    key: 'total_penulisan',
                    title: 'Penulisan 20%',
                    align: 'center',
                    scopedSlots: {customRender: 'total_penulisan'},
                },
            ]
        },
        {
            key: 'final_score',
            title: 'Nilai Akhir',
            align: 'center',
            scopedSlots: {customRender: 'final_score'}
        }
    ]

    export default {
        data() {
            return {
                columns,
                items: [],
                loading: false
            }
        },
        created() {
            this.getItems()
        },
        methods: {
            getItems(){
                let params = {
                    user_hash: this.$laravel.user.hash,
                    recap_type: 'attendant'
                }

                this.loading = true

                this.$http
                    .get(this.routeUri('api.recap.activity-score.attendants_result')+ '?' + this.$qs.stringify(params))
                    .then(response => this.items = response.data.attendants)
                    .catch(error => this.handleXhrError(error))
                    .finally(() => (this.loading = false))
            },
        },
        computed: {
            tableData(){
                if(this.items.length > 0){
                    let idx = 0
                    let collection = []
                    let scorer = {}
                    let idx2 = 0
                    let totPresentasi = 0
                    let totIsi = 0
                    let totPenulisan = 0

                    this.items.forEach(function(item){
                        idx++
                        item.evaluators.forEach(function(evaluator){
                            let scoreEvaluator = item.activities[0].evaluator_score[evaluator]
                            if(Array.isArray(scoreEvaluator)){
                                idx2++
                                scoreEvaluator.forEach(function(score){
                                    if(score.scoreable.scoreable_type === 'aspect' && score.scoreable.code === 'PPR-PRM'){
                                        scorer['presentasi_'+idx2] = score.raw_score
                                        totPresentasi = parseFloat(totPresentasi) + parseFloat(score.score)
                                    }else if(score.scoreable.scoreable_type === 'aspect' && score.scoreable.code === 'PPR-CTN'){
                                        scorer['isi_'+idx2] = score.raw_score
                                        totIsi = parseFloat(totIsi) + parseFloat(score.score)
                                    }else if(score.scoreable.scoreable_type === 'aspect' && score.scoreable.code === 'PPR-TEK'){
                                        scorer['penulisan_'+idx2] = score.raw_score
                                        totPenulisan = parseFloat(totPenulisan) + parseFloat(score.score)
                                    }

                                })
                            }
                        })

                        let presentasi = totPresentasi / idx2
                        let isi = totIsi / idx2
                        let penulisan = totPenulisan / idx2

                        if(isNaN(presentasi)){
                            presentasi = 0
                        }
                        if(isNaN(isi)){
                            isi = 0
                        }
                        if(isNaN(penulisan)){
                            penulisan = 0
                        }

                        scorer['total_presentasi'] = parseFloat(presentasi).toFixed(2)
                        scorer['total_isi'] = parseFloat(isi).toFixed(2)
                        scorer['total_penulisan'] = parseFloat(penulisan).toFixed(2)

                        scorer['final_score'] = parseFloat(presentasi + isi + penulisan).toFixed(2)
                        collection.push({
                            id: idx,
                            scorer
                        })
                    })

                    return collection
                }

                return []
            }
        },
    }
</script>
